<template>
  <div>
    <vx-card ref="filterCard" title="Filtros" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Tipo</label>
          <v-select :options="typeOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="typeFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Produto</label>
          <v-select :options="productNameOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="productNameFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Quantidade</label>
          <v-select :options="quantityOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="quantityFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Período</label>
          <v-select :options="timeOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="timeFilter" class="mb-4 md:mb-0" />
        </div>
      </div>
    </vx-card>

    <div class="algolia-header mb-4">
      <div class="flex md:items-end items-center justify-between flex-wrap">
        <feather-icon class="inline-flex lg:hidden cursor-pointer mr-4" icon="MenuIcon" @click.stop="toggleFilterSidebar" />
        <div class="flex justify-between items-end flex-grow">
          <div class="flex flex-wrap">
            <!-- SORTING -->
              <vs-select :value="currentRefinement" slot-scope="{ items, currentRefinement, refine }"
                @input="(val) => refine(val)" class="mr-4 vs-input-shadow-drop vs-select-no-border d-theme-input-dark-bg w-48">
                <vs-select-item v-for="item in items" :key="item.value" :value="item.value" :text="item.label" />
              </vs-select>
            <!-- ITEM VIEW - GRID/LIST -->
            <div>
              <feather-icon icon="GridIcon" @click="currentItemView='item-grid-view'"
                class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                :svgClasses="{'text-primary stroke-current': currentItemView == 'item-grid-view'}" />
              <feather-icon icon="ListIcon" @click="currentItemView='item-list-view'"
                class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer hidden sm:inline-flex"
                :svgClasses="{'text-primary stroke-current': currentItemView == 'item-list-view'}" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="relative clearfix">
      <!-- RIGHT COL -->
      <div>
        <!-- SEARCH RESULT -->
        <div>
          <!-- GRID VIEW -->
          <template v-if="currentItemView == 'item-grid-view'">
            <div class="items-grid-view vx-row match-height">
              <div class="vx-col lg:w-1/3 sm:w-1/2 w-full" v-for="(item, index) in filteredShelfs" :key="index">
                <item-grid-view :item="item" :groupedMovements="groupedMovements" @createOutput="(data) => { createOutput(data) }">
                  <template slot="action-buttons">
                    <div class="flex flex-wrap">
                      <div class="item-view-primary-action-btn bg-danger p-3 flex flex-grow items-center justify-center text-white cursor-pointer" @click="processButtonClicked(item)">
                        <feather-icon icon="CpuIcon" :svgClasses="[{ 'text-danger fill-current' : false }, 'h-4 w-4']" />
                        <span class="text-sm font-semibold ml-2" v-if="isInStorage(item, 'process')">VER EM PROCESSAMENTO</span>
                        <span class="text-sm font-semibold ml-2" v-else>+ PROCESSAMENTO</span>
                      </div>
                      <div class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer" @click="cartButtonClicked(item)">
                        <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4"/>
                        <span class="text-sm font-semibold ml-2" v-if="isInStorage(item, 'checkout')">VER EM EXPEDIÇÃO</span>
                        <span class="text-sm font-semibold ml-2" v-else>+ EXPEDIÇÃO</span>
                      </div>
                    </div>
                  </template>
                </item-grid-view>
              </div>
            </div>
          </template>

          <!-- LIST VIEW -->
          <template v-else>
            <div class="items-list-view mb-base" v-for="(item, index) in filteredShelfs" :key="index">
              <item-list-view :item="item" :groupedMovements="groupedMovements">
                <!-- SLOT: ACTION BUTTONS -->
                <template slot="action-buttons">
                  <div class="item-view-primary-action-btn bg-danger p-3 rounded-lg flex flex-grow items-center justify-center text-white cursor-pointer mb-3" @click="processButtonClicked(item)">
                    <feather-icon icon="CpuIcon" :svgClasses="[{ 'text-danger fill-current' : false }, 'h-4 w-4']" />
                    <span class="text-sm font-semibold ml-2" v-if="isInStorage(item, 'process')">VER EM PROCESSAMENTO</span>
                    <span class="text-sm font-semibold ml-2" v-else>+ PROCESSAMENTO</span>
                  </div>
                  <div class="item-view-secondary-action-btn bg-primary p-3 rounded-lg flex flex-grow items-center justify-center text-white cursor-pointer" @click="cartButtonClicked(item)">
                    <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4"/>
                    <span class="text-sm font-semibold ml-2" v-if="isInStorage(item, 'checkout')">VER EM EXPEDIÇÃO</span>
                    <span class="text-sm font-semibold ml-2" v-else>+ EXPEDIÇÃO</span>
                  </div>
                </template>
              </item-list-view>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
  components: {
    vSelect,
    ItemGridView: () => import('./components/ItemGridView.vue'),
    ItemListView: () => import('./components/ItemListView.vue')
  },
  data () {
    return {
      shelfs: [],
      process: [],
      checkout: [],
      movements: [],
      filteredShelfs: [],
      groupedMovements: [],
      // Filter Sidebar
      typeFilter: { label: 'Todos', value: 'all' },
      productNameFilter: { label: 'Todos', value: 'all' },
      quantityFilter: { label: 'Todos', value: 'all' },
      timeFilter: { label: 'Todos', value: 'all' },
      isFilterSidebarActive: true,
      clickNotClose: true,
      currentItemView: 'item-grid-view',
      numericItems: [
        { label: 'All' },
        { label: '<= $10', end: 10 },
        { label: '$10 - $100', start: 10, end: 100 },
        { label: '$100 - $500', start: 100, end: 500 },
        { label: '>= $500', start: 500 }
      ]
    }
  },
  computed: {
    productNameOptions () {
      const res = [{ label: 'Todos', value: 'all' }]
      for (let i = 0; i < this.shelfs.length; i++) {
        if (!res.map(e => e.label).includes(this.shelfs[i].name)) res.push({ label: this.shelfs[i].name, value: this.shelfs[i].name })
      }
      return res
    },
    typeOptions () {
      return [
        { label: 'Todos', value: 'all' },
        { label:'Embalagem', value: 'packing' },
        { label:'Natural', value: 'natural' },
        { label:'Processado', value: 'processed' },
        { label:'Resíduo', value: 'residue' }
      ]
    },
    quantityOptions () {
      return [
        { label: 'Todos', value: 'all' },
        { label: 'Menor que 10', value: [0, 10] },
        { label: 'Entre 10 e 100', value: [10, 100] },
        { label: 'Entre 100 e 1000', value: [100, 10000] },
        { label: 'Acima de 1000', value: [1000, 999999999999] }
      ]
    },
    timeOptions () {
      const today = new Date()
      return [
        { label: 'Todos', value: 'all' },
        { label: 'Hoje', value: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0) },
        { label: 'Últimos 7 dias', value: new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000)) },
        { label: 'Últimos 15 dias', value: new Date(new Date().getTime() - (15 * 24 * 60 * 60 * 1000)) },
        { label: 'Últimos 30 dias', value: new Date(new Date().getTime() - (30 * 24 * 60 * 60 * 1000)) },
        { label: 'Últimos 60 dias', value: new Date(new Date().getTime() - (60 * 24 * 60 * 60 * 1000)) },
        { label: 'Últimos 90 dias', value: new Date(new Date().getTime() - (90 * 24 * 60 * 60 * 1000)) }
      ]
    },
    // GRID VIEW
    isInStorage () {
      return (item, itemName) => {
        if (itemName === 'checkout') return this.checkout.find(e => e.id === item.id)
        else return this.process.find(e => e.id === item.id)
      }
    },
    userHeaders () { return { headers: { Authorization: localStorage.getItem('accessToken') } } },
    windowWidth () { return this.$store.state.windowWidth }
  },
  watch: {
    windowWidth () { this.setSidebarWidth() },
    process (value) { localStorage.setItem('process', JSON.stringify(value.length ? value : [])) },
    checkout (value) { localStorage.setItem('checkout', JSON.stringify(value.length ? value : [])) }
  },
  methods: {
    resetColFilters () {
      this.typeFilter = { label: 'Todos', value: 'all' }
      this.timeFilter = { label: 'Todos', value: 'all' }
      this.productNameFilter = { label: 'Todos', value: 'all' }
      this.quantityFilter = { label: 'Todos', value: 'all' }
      this.filteredShelfs = this.positiveShelfs(this.shelfs)
      this.$refs.filterCard.removeRefreshAnimation()
    },
    positiveShelfs (shelfs) {
      const result = []
      let filteredMoves = null
      for (let i = 0; i < shelfs.length; i++) {
        filteredMoves = this.groupedMovements.find(e => e.ProductId === shelfs[i].LotsProduct.ProductId)
        if (filteredMoves && filteredMoves.quantity > 0 && !result.map(e => e.id).includes(shelfs[i].id)) result.push(shelfs[i])
      }
      return result
    },
    async getShelfs () {
      try {
        this.$vs.loading()
        const { data } = await this.$http.get('/api/v1/admin/shelfs', this.userHeaders)
        this.shelfs = data
        this.filteredShelfs = this.positiveShelfs(this.shelfs)
      } catch (e) {
        console.log(e)
      } finally { this.$vs.loading.close() }
    },
    async getStock () {
      try {
        this.$vs.loading()
        const { data } = await this.$http.get('/api/v1/admin/company/movements', this.userHeaders)
        this.movements = data
        await this.groupMovements()
      } catch (err) {
        console.log(err)
      } finally {
        this.$vs.loading.close()
      }
    },
    async createOutput (d) {
      const { data, item } = d
      const id = item.LotsProduct.LotId
      try {
        this.$vs.loading()
        await this.$http.post(`/api/v1/admin/company/movements?lotId=${id}`, data, this.userHeaders)
        this.$vs.notify({
          title: 'Baixa criada',
          text: 'Baixa criado com sucesso',
          iconPack: 'feather',
          color: 'success'
        })
        this.$router.go()
      } catch (err) {
        console.log(err)
        this.$vs.notify({
          title: 'Erro na criação de baixa',
          text: 'Não foi possível dar baixa no estoque',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      } finally {
        this.$vs.loading.close()
      }
    },
    groupMovements () {
      this.movements = this.movements
      const groupedProductId = []
      for (let i = 0; i < this.movements.length; i++) {
        if (!groupedProductId.includes(this.movements[i].ProductId)) {
          groupedProductId.push(this.movements[i].ProductId)
        }
      }
      for (let j = 0; j < groupedProductId.length; j++) {
        const filteredMovements = this.movements.filter(e => e.ProductId === groupedProductId[j])
        let quantitySum = 0
        let priceSum = 0
        for (let k = 0; k < filteredMovements.length; k++) {
          quantitySum = filteredMovements[k].cause === 'Saída' ? quantitySum - filteredMovements[k].quantity : quantitySum + filteredMovements[k].quantity
          priceSum = filteredMovements[k].cause === 'Saída' ? priceSum - (filteredMovements[k].quantity * filteredMovements[k].price) : priceSum + (filteredMovements[k].quantity * filteredMovements[k].price)
        }
        this.groupedMovements.push({
          MovementId: filteredMovements[0].id, 
          Product: filteredMovements[0].Product,
          ProductId: filteredMovements[0].ProductId,
          quantity: quantitySum,
          price: priceSum
        })
      }
    },
    setSidebarWidth () {
      if (this.windowWidth < 992) {
        this.isFilterSidebarActive = this.clickNotClose = false
      } else {
        this.isFilterSidebarActive = this.clickNotClose = true
      }
    },
    // GRID VIEW - ACTIONS
    toggleFilterSidebar () {
      if (this.clickNotClose) return
      this.isFilterSidebarActive = !this.isFilterSidebarActive
    },
    addStorageItem (item, itemName) {
      if (itemName === 'process') {
        this.process.push(item)
        this.process = this.process
      } else {
        this.checkout.push(item)
        this.checkout = this.checkout
      }
    },
    cartButtonClicked (item) {
      this.isInStorage(item, 'checkout') ? this.$router.push('/apps/products/shelfs/checkout').catch(() => {}) : this.addStorageItem(item, 'checkout')
    },
    processButtonClicked (item) {
      this.isInStorage(item, 'process') ? this.$router.push('/apps/products/shelfs/process').catch(() => {}) : this.addStorageItem(item, 'process')
    }
  },
  created () { this.setSidebarWidth() },
  mounted () {
    this.process = JSON.parse(localStorage.getItem('process'))
    this.checkout = JSON.parse(localStorage.getItem('checkout'))
    this.process = this.process ? this.process : []
    this.checkout = this.checkout ? this.checkout : []
    this.getStock()
    this.getShelfs()
  }
}
</script>

<style lang="scss">
  #algolia-instant-search-demo {
    .algolia-header {
      .algolia-filters-label {
        width: calc(260px + 2.4rem);
      }
    }

    #algolia-content-container {

      .vs-sidebar {
        position: relative;
        float: left;
      }
    }

    .algolia-search-input-right-aligned-icon {
      padding: 1rem 1.5rem;
    }

    .algolia-price-slider {
      min-width: unset;
    }

    .item-view-primary-action-btn {
      color: #2c2c2c !important;
      background-color: #f6f6f6;
      min-width: 50%;
    }

    .item-view-secondary-action-btn {
      min-width: 50%;
    }
  }

  .theme-dark {
    #algolia-instant-search-demo {
      #algolia-content-container {
        .vs-sidebar {
          background-color: #10163a;
        }
      }
    }
  }

  @media (min-width: 992px) {
    .vs-sidebar-rounded {
      .vs-sidebar {
        border-radius: .5rem;
      }

      .vs-sidebar--items {
        border-radius: .5rem;
      }
    }
  }

  @media (max-width: 992px) {
    #algolia-content-container {
      .vs-sidebar {
        position: absolute !important;
        float: none !important;
      }
    }
  }
</style>

